let createActionName = require('../util').createActionName('navigation');

export const SHOW_NAV_MODAL = createActionName('DISPLAY_NAV_MODAL');
export const HIDE_NAV_MODAL = createActionName('HIDE_NAV_MODAL');

export const showNavModal = (data, isExternal) => {
  return {
    type: SHOW_NAV_MODAL,
    payload: data,
    isExternal: isExternal,
  };
};

export const hideNavModal = () => ({
  type: HIDE_NAV_MODAL,
});
